module.exports = vendor_0cd94df7c05328075e52;